import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withKeys as _withKeys, vModelText as _vModelText, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09ab4795"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-edit-modal" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = { class: "line1" }
const _hoisted_4 = { class: "line2" }
const _hoisted_5 = { class: "ls-form" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Type", -1))
const _hoisted_7 = { class: "radio-group" }
const _hoisted_8 = { class: "radio" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "PC")
], -1))
const _hoisted_11 = { class: "radio" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text nowrap" }, "Non-PC")
], -1))
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = { class: "col-6" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "LawID / Name", -1))
const _hoisted_17 = {
  key: 0,
  class: "autocomplete",
  style: {"flex":"0 0 100%"}
}
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "icon-hm" }
const _hoisted_20 = {
  key: 0,
  class: "fal fa-spinner fa-spin fa-lg"
}
const _hoisted_21 = {
  key: 1,
  class: "fal fa-search fa-lg"
}
const _hoisted_22 = {
  id: "autocomplete-results",
  class: "autocomplete-results"
}
const _hoisted_23 = ["innerHTML", "onClick"]
const _hoisted_24 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_26 = {
  key: 1,
  class: "input-box"
}
const _hoisted_27 = ["disabled", "value"]
const _hoisted_28 = { class: "col-6" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Category *", -1))
const _hoisted_30 = { class: "input-box" }
const _hoisted_31 = {
  class: "select mb-4",
  style: {"width":"100%"}
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: "0"
}, "- Please select -", -1))
const _hoisted_33 = ["value"]
const _hoisted_34 = {
  key: 0,
  class: "validation-msg",
  style: {"position":"absolute","margin-top":"4.6em"}
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_36 = {
  key: 1,
  class: "row"
}
const _hoisted_37 = { class: "col-6" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "First name *", -1))
const _hoisted_39 = { class: "input-box" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_43 = { class: "col-6" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Last name *", -1))
const _hoisted_45 = { class: "input-box" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_49 = {
  key: 2,
  class: "row"
}
const _hoisted_50 = { class: "col-12" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Category *", -1))
const _hoisted_52 = { class: "input-box" }
const _hoisted_53 = {
  class: "select mb-4",
  style: {"width":"100%"}
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: "0"
}, "- Please select -", -1))
const _hoisted_55 = ["value"]
const _hoisted_56 = {
  key: 0,
  class: "validation-msg",
  style: {"position":"absolute","margin-top":"4.6em"}
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col-12" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Solely/ jointly *", -1))
const _hoisted_61 = { class: "input-box" }
const _hoisted_62 = {
  class: "select mb-4",
  style: {"width":"100%"}
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: "0"
}, "- Please select -", -1))
const _hoisted_64 = ["value"]
const _hoisted_65 = {
  key: 0,
  class: "validation-msg",
  style: {"position":"absolute","margin-top":"4.6em"}
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_67 = { class: "row" }
const _hoisted_68 = { class: "col-6" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Commenced Date *", -1))
const _hoisted_70 = { class: "input-box" }
const _hoisted_71 = {
  class: "date-picker",
  style: {"width":"100%"}
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-calendar-check" }, null, -1))
const _hoisted_73 = { class: "col-6" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Terminated Date", -1))
const _hoisted_75 = { class: "input-box" }
const _hoisted_76 = {
  class: "date-picker",
  style: {"width":"100%"}
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-calendar-check" }, null, -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_79 = { class: "row" }
const _hoisted_80 = {
  key: 0,
  class: "col-6"
}
const _hoisted_81 = ["disabled"]
const _hoisted_82 = ["disabled"]
const _hoisted_83 = ["disabled"]
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-right" })
], -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "CANCEL ALERT", -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Do you want to cancel this task?", -1))

export function render(_ctx, _cache) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_v3_date_picker = _resolveComponent("v3-date-picker")
  const _component_ModalBox = _resolveComponent("ModalBox")
  const _component_ConfirmDialogue = _resolveComponent("ConfirmDialogue")
  const _component_AlertBox = _resolveComponent("AlertBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.isLoadingData)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalBox, {
      show: _ctx.show,
      "onUpdate:show": _cache[24] || (_cache[24] = $event => ((_ctx.show) = $event)),
      onClose: _cache[25] || (_cache[25] = $event => (_ctx.cancelClicked()))
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.headerText), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.line2Text), 1)
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("form", _hoisted_5, [
          _createElementVNode("fieldset", null, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "member-type",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.signatoryRequest.signatoryTypeId) = $event)),
                  value: 1,
                  disabled: _ctx.editMode
                }, null, 8, _hoisted_9), [
                  [_vModelRadio, _ctx.signatoryRequest.signatoryTypeId]
                ]),
                _hoisted_10
              ]),
              _createElementVNode("label", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "member-type",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.signatoryRequest.signatoryTypeId) = $event)),
                  value: 2,
                  disabled: _ctx.editMode
                }, null, 8, _hoisted_12), [
                  [_vModelRadio, _ctx.signatoryRequest.signatoryTypeId]
                ]),
                _hoisted_13
              ])
            ])
          ]),
          (_ctx.signatoryRequest.signatoryTypeId == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("fieldset", _hoisted_15, [
                  _hoisted_16,
                  (!_ctx.editMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          onKeydown: [
                            _cache[2] || (_cache[2] = _withKeys((...args) => (_ctx.onArrowDown && _ctx.onArrowDown(...args)), ["down"])),
                            _cache[3] || (_cache[3] = _withKeys((...args) => (_ctx.onArrowUp && _ctx.onArrowUp(...args)), ["up"])),
                            _cache[4] || (_cache[4] = _withKeys((...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"]))
                          ],
                          disabled: _ctx.editMode,
                          class: "searchField",
                          type: "text",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.search) = $event)),
                          placeholder: "Search LawID,  name"
                        }, null, 40, _hoisted_18), [
                          [_vModelText, _ctx.search]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "hidden",
                          id: "lawId",
                          name: "lawId",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.signatoryRequest.lawId) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.signatoryRequest.lawId]
                        ]),
                        _createElementVNode("span", _hoisted_19, [
                          (_ctx.isSearching)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                            : (_openBlock(), _createElementBlock("i", _hoisted_21))
                        ]),
                        _withDirectives(_createElementVNode("ul", _hoisted_22, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userList, (user, i) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: i,
                              class: _normalizeClass(["autocomplete-result", { 'is-active': i === _ctx.arrowCounter }]),
                              innerHTML: _ctx.highlightWord(user.lawId + ' - ' + user.givenName + ' ' + user.surname),
                              onClick: _withModifiers($event => (_ctx.selectUser(user)), ["prevent"])
                            }, null, 10, _hoisted_23))
                          }), 128))
                        ], 512), [
                          [_vShow, _ctx.isOpen]
                        ]),
                        (_ctx.signatoryRequest.lawId == '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _hoisted_25,
                              _createTextVNode(" Mandatory field ")
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.editMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("input", {
                          style: {"margin-top":"0 !important"},
                          type: "text",
                          disabled: _ctx.editMode,
                          placeholder: "Law ID",
                          value: _ctx.signatoryRequest.lawId + ' - ' + _ctx.signatoryRequest.firstName + ' ' + _ctx.signatoryRequest.lastName
                        }, null, 8, _hoisted_27)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("fieldset", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.signatoryRequest.categoryId) = $event)),
                        onChange: _cache[8] || (_cache[8] = $event => (_ctx.mandatoryCheck()))
                      }, [
                        _hoisted_32,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (c) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: c.id
                          }, _toDisplayString(c.name), 9, _hoisted_33))
                        }), 256))
                      ], 544), [
                        [_vModelSelect, _ctx.signatoryRequest.categoryId]
                      ]),
                      (_ctx.signatoryRequest.categoryId == '0')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                            _hoisted_35,
                            _createTextVNode(" Mandatory field ")
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.signatoryRequest.signatoryTypeId == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createElementVNode("fieldset", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("div", _hoisted_39, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.signatoryRequest.firstName) = $event)),
                      disabled: _ctx.isLoadingData,
                      placeholder: "First name",
                      onInput: _cache[10] || (_cache[10] = $event => (_ctx.mandatoryCheck())),
                      maxLength: "50"
                    }, null, 40, _hoisted_40), [
                      [_vModelText, _ctx.signatoryRequest.firstName]
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["footnote", [ _ctx.signatoryRequest.firstName.length === 50 ? 'full' : '']])
                    }, _toDisplayString(_ctx.signatoryRequest.firstName.length) + "/50 characters ", 3),
                    (_ctx.signatoryRequest.firstName === '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _hoisted_42,
                          _createTextVNode(" Mandatory field ")
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("fieldset", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("div", _hoisted_45, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.signatoryRequest.lastName) = $event)),
                      disabled: _ctx.isLoadingData,
                      placeholder: "Last name",
                      onInput: _cache[12] || (_cache[12] = $event => (_ctx.mandatoryCheck())),
                      maxLength: "50"
                    }, null, 40, _hoisted_46), [
                      [_vModelText, _ctx.signatoryRequest.lastName]
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["footnote", [ _ctx.signatoryRequest.lastName.length === 50 ? 'full' : '']])
                    }, _toDisplayString(_ctx.signatoryRequest.lastName.length) + "/50 characters ", 3),
                    (_ctx.signatoryRequest.lastName === '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _hoisted_48,
                          _createTextVNode(" Mandatory field ")
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.signatoryRequest.signatoryTypeId == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _createElementVNode("fieldset", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.signatoryRequest.categoryId) = $event)),
                        onChange: _cache[14] || (_cache[14] = $event => (_ctx.mandatoryCheck()))
                      }, [
                        _hoisted_54,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (c) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: c.id
                          }, _toDisplayString(c.name), 9, _hoisted_55))
                        }), 256))
                      ], 544), [
                        [_vModelSelect, _ctx.signatoryRequest.categoryId]
                      ]),
                      (_ctx.signatoryRequest.categoryId == '0')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_56, [
                            _hoisted_57,
                            _createTextVNode(" Mandatory field ")
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("fieldset", _hoisted_59, [
              _hoisted_60,
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => ((_ctx.signatoryRequest.solelyJointlyId) = $event)),
                    onChange: _cache[16] || (_cache[16] = $event => (_ctx.mandatoryCheck()))
                  }, [
                    _hoisted_63,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.solelyJointlyType, (sT) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: sT.id
                      }, _toDisplayString(sT.name), 9, _hoisted_64))
                    }), 256))
                  ], 544), [
                    [_vModelSelect, _ctx.signatoryRequest.solelyJointlyId]
                  ]),
                  (_ctx.signatoryRequest.solelyJointlyId == 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_65, [
                        _hoisted_66,
                        _createTextVNode(" Mandatory field ")
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("fieldset", _hoisted_68, [
              _hoisted_69,
              _createTextVNode(" Please enter the date the person become a signatory "),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _createVNode(_component_v3_date_picker, {
                    class: "v3-date-picker",
                    style: {"padding":"1em"},
                    onClick: _cache[17] || (_cache[17] = $event => (_ctx.mandatoryCheck())),
                    modelValue: _ctx.signatoryRequest.commencedDate,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => ((_ctx.signatoryRequest.commencedDate) = $event)),
                    inputFormat: "dd-MM-yyyy"
                  }, null, 8, ["modelValue"]),
                  _hoisted_72
                ])
              ])
            ]),
            _createElementVNode("fieldset", _hoisted_73, [
              _hoisted_74,
              _createTextVNode(" If ongoing, please leave blank "),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _createVNode(_component_v3_date_picker, {
                    class: "v3-date-picker",
                    style: {"padding":"1em"},
                    onClick: _cache[19] || (_cache[19] = $event => (_ctx.mandatoryCheck())),
                    modelValue: _ctx.signatoryRequest.terminatedDate,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => ((_ctx.signatoryRequest.terminatedDate) = $event)),
                    inputFormat: "dd-MM-yyyy",
                    lowerLimit: _ctx.from
                  }, null, 8, ["modelValue", "lowerLimit"]),
                  _hoisted_77
                ])
              ])
            ])
          ]),
          _hoisted_78
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_79, [
          (_ctx.editMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                _createElementVNode("button", {
                  class: "btn btn-outline",
                  onClick: _cache[21] || (_cache[21] = $event => (_ctx.deleteAuthroisedSignatory())),
                  disabled: _ctx.isLoadingData
                }, "Delete", 8, _hoisted_81)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.editMode ? 'col-6 right' : 'col-12 right')
          }, [
            _createElementVNode("button", {
              class: "btn btn-default",
              onClick: _cache[22] || (_cache[22] = $event => (_ctx.cancelClicked())),
              disabled: _ctx.isLoadingData
            }, "Cancel", 8, _hoisted_82),
            _createElementVNode("button", {
              class: "btn btn-primary ml-2",
              disabled: !_ctx.canSubmit || _ctx.isLoadingData,
              onClick: _cache[23] || (_cache[23] = $event => (_ctx.submit()))
            }, [
              _createTextVNode(_toDisplayString(_ctx.submitBtnText) + " ", 1),
              _hoisted_84
            ], 8, _hoisted_83)
          ], 2)
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ConfirmDialogue, {
      ref: "confirmTerminateDialogue",
      modalOpened: true
    }, null, 512),
    (_ctx.showCancelAlert)
      ? (_openBlock(), _createBlock(_component_AlertBox, {
          key: 1,
          onClose: _cache[28] || (_cache[28] = $event => (_ctx.showCancelAlert = false))
        }, {
          header: _withCtx(() => [
            _hoisted_85
          ]),
          body: _withCtx(() => [
            _hoisted_86
          ]),
          footer: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn btn-secondary sml",
              onClick: _cache[26] || (_cache[26] = $event => (_ctx.yesClicked()))
            }, "Yes"),
            _createElementVNode("button", {
              class: "btn btn-tertiary sml",
              onClick: _cache[27] || (_cache[27] = $event => (_ctx.showCancelAlert = false))
            }, "No")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}